import { render, staticRenderFns } from "./LayoutBreadcrumbCartao.vue?vue&type=template&id=67e2ac9c"
import script from "./LayoutBreadcrumbCartao.vue?vue&type=script&lang=js"
export * from "./LayoutBreadcrumbCartao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports